import type { ChakraProps } from '@chakra-ui/react';
import { chakra, VisuallyHidden } from '@chakra-ui/react';

interface ISocialButtonProps extends ChakraProps {
  children: React.ReactNode;
  href: string;
  label: string;
}

export const SocialButton: React.FC<ISocialButtonProps> = ({
  children,
  href,
  label,
  ...rest
}): JSX.Element => {
  return (
    <chakra.button
      alignItems="center"
      as="a"
      bg="white"
      cursor="pointer"
      display="inline-flex"
      fontSize={{ base: 'xl', sm: 'md' }}
      h={{ base: 12, sm: 8 }}
      href={href}
      justifyContent="center"
      transition="background 0.3s ease"
      w={{ base: 12, sm: 8 }}
      {...rest}
    >
      <VisuallyHidden>{label}</VisuallyHidden>
      {children}
    </chakra.button>
  );
};
